export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  text: {
    color: theme.custom.colors.text,
    justifySelf: 'center',
  },
});
